import BoilerplateForm from './boilerplate_form';
import { html } from 'lit';
import { ref } from 'lit/directives/ref.js';
import { ifDefined } from 'lit/directives/if-defined.js';

export class WishlistCreateBoardForm extends BoilerplateForm {
  static get properties() {
    return {
      success: { type: Boolean, state: true },
      themes: { type: Object, attribute: true },
      emojis: { type: Object, attribute: true },
      detail: { type: Object, attribute: true },
    };
  }

  constructor() {
    super();
    this.useUrlParams = false;
  }

  async handleSubmit(event) {
    event.preventDefault();

    this.errors = {};
    this.genericErrorSegments = [];
    this.success = false;
    this.busy = true;
    this.loading = true;

    const fields = this.objectData;

    if (!fields.boardColour) {
      fields.boardColour =
        this.boardColour?.value ||
        window.wishlist_colours.find((c) => c.default === true).value;
    }

    if (!fields.boardEmoji) {
      fields.boardEmoji =
        this.boardEmoji?.value ||
        window.wishlist_emojis.find((e) => e.default === true).emoji;
    }

    try {
      const wishlist = await window.wishlist.createBoard(
        fields.boardName,
        fields.boardColour,
        fields.boardEmoji
      );

      if (
        this.detail?.items &&
        this.detail.items.length > 0 &&
        this.detail.currentBoard
      ) {
        const justCreatedBoard = wishlist.boards.find(
          (board) => board.name === fields.boardName
        );

        await window.wishlist.moveProductToBoard(
          this.detail?.items,
          this.detail?.currentBoard?.id,
          justCreatedBoard?.id
        );
      }

      this.handleSuccess();
      window.dispatchEvent(
        new CustomEvent('analytics:gtag', {
          detail: {
            event: 'wishlist_board_create',
            params: {
              board_name: fields.boardName,
              shopiify_customer_id: window.theme?.customer?.id || null,
            },
          },
        })
      );
    } catch (error) {
      const errorArr = Array.isArray(error) ? error : [error];
      this.handleErrors(errorArr);
    } finally {
      this.busy = false;
      this.loading = false;
    }
  }

  renderFormElements() {
    if (!window.wishlist_emojis || !window.wishlist_colours) return nothing;

    const colours =
      window.wishlist_colours?.filter((c) => !c.value.startsWith('_')) ||
      window.wishlist_colours;

    return html`<div class="form_wishlist_board" dropdown-parent>
      <float-field
        type="text"
        minlength="3"
        maxlength="25"
        name="boardName"
        id=${`${this.id}_boardName`}
        label="Board Name"
        required
        error="Please enter a name for your board"
        placeholder="Board Name"
      ></float-field>
      <div class="float_dropdowns_container">
        <float-dropdown
          ${ref((el) => (this.boardEmoji = el))}
          name="boardEmoji"
          id=${`${this.id}_boardEmoji`}
          type="emoji"
          .options=${window.wishlist_emojis}
          aria-label="Emoji picker dropdown"
        >
        </float-dropdown>
        <float-dropdown
          ${ref((el) => (this.boardColour = el))}
          id=${`${this.id}_boardColour`}
          name="boardColour"
          type="colour"
          .options=${colours}
          aria-label="Colour picker dropdown"
        >
        </float-dropdown>
      </div>
    </div>`;
  }

  handleSuccess() {
    this.errors = {};
    this.genericErrorSegments = [];
    this.success = true;
    this.loading = false;
    this.busy = false;

    const closeModal = new CustomEvent('modal-wishlist-create-board:close');
    document.dispatchEvent(closeModal);
    this.resetEmitter();
  }

  renderInitial() {
    return html`<form
      ${ref((el) => (this.form = el))}
      method=${ifDefined(this.method)}
      ?novalidate=${this.novalidate}
      enctype=${ifDefined(this.enctype)}
      class="${this.id}"
      action="javascript:void(0)"
    >
      ${this.renderFormElements()} ${this.renderButton()} ${this.renderErrors()}
    </form>`;
  }

  renderButton() {
    return html`
      <button
        type="submit"
        class="btn btn-tertiary w-100"
        aria-label="Create board"
        ?disabled=${this.loading || this.busy}
        aria-busy=${this.loading || this.busy ? 'true' : 'false'}
      >
        ${this.loading
          ? html`<bouncing-ellipsis></bouncing-ellipsis>`
          : html`${window.theme.strings.wishlist.create_board}`}
      </button>
    `;
  }
}

window.customElements.get('wishlist-create-board-form') ||
  window.customElements.define(
    'wishlist-create-board-form',
    WishlistCreateBoardForm
  );
